<template>
	<!-- 报表 
	可能会做修改保存的操作 -->
	<div class="el-container container_cloumn" v-loading="pageloading">
		<el-header style="height: auto;">
			<vxe-toolbar>
				<template v-slot:buttons>
					<div class="flex flex_row flex-nowrap">
						<vxe-button type="text" class="tool-btn _icon_button" title="异常关闭" v-if="(menuId=='GYSErr'||menuId=='GYSDo')&&userinfo.accountType=='cgy'"
							@click="errorClose" :loading="errCloseload" :disabled="loading">
							<i class="iconfont icon-Powershutdownstart iconSize "></i>异常关闭
						</vxe-button>
						<vxe-button type="text" class="tool-btn _icon_button" title="物料标签打印" v-if="menuId=='GYSASNLabel'"
							@click="itemprint" :loading="printLoad" :disabled="loading">
							<i class="iconfont icon-print iconSize "></i>物料标签打印
						</vxe-button>
						<vxe-button type="text" class="tool-btn _icon_button" title="导出" @click="exportData" :loading="exportload" :disabled="exportload">
							<i class="iconfont icon-export iconSize "></i>导出
						</vxe-button>
						<vxe-button type="text" class="tool-btn _icon_button" title="更多筛选"
							v-if="filterList.length>2"
							@click="filterClose=!filterClose">
							<i class="vxe-icon--funnel"></i>更多筛选
						</vxe-button>
					</div>
				</template>
			</vxe-toolbar>
			<div class="flex flex_row flex-nowrap">
				<div class="pursh_filter" :style="filterClose?'width: 70%;':'width: 45%;'">
					<table>
						<template v-for="item of TableRowCount">
							<tr :key="item">
								<template v-for="jitem of TableRowSpan">
									<td :colspan="6" v-if="showFilters[(item-1)*TableRowSpan+jitem-1]" :key="jitem">
										<!-- {{(item-1)*TableRowSpan+jitem}}/{{TableRowSpan}} -->
										<c-filter :dataSource="[showFilters[(item-1)*TableRowSpan+jitem-1]]" :form="filterForm" :line="true"
											:textMini="40" :VailShow="VailShow"></c-filter>
									</td>
								</template>
							</tr>
						</template>
					</table>
				</div>
				<div class="filter_btns">
					<el-button  type="primary" class="pursh_mainBtn" @click="select" :loading="loading" :disabled="loading||exportload">查询</el-button>
					<el-button class="pursh_mainBtn" @click="clearItem"> 清除</el-button>
				</div>
			</div>
			
		</el-header>
		<el-main class="pursh_main" style="height: calc(100% - 100px);" v-loading="loading">
			<!-- <div style="height: 100%;"> -->
				<c-table ref="ctable" style="height: calc(100% - 20px);" 
					:table="table" @listenToChild="listenToChild" @FitColumns="table.head=$event" 
					class="table_height print_selecttable_div" :cellClass="tableCellClass()"  :coltype="menuId=='GYSASNLabel'||menuId=='GYSErr'||menuId=='GYSDo'?'checkbox':'seq'"></c-table>
			<!-- </div> -->
			<!-- <c-table ref="ctable" :table="table" class="table_height print_selecttable_div" 
				v-loading="loading" coltype="checkbox" :rowClass="tableRowClass"></c-table> -->
		</el-main>
		<!-- <div class="table_height">123</div> @close="$refs.ctable.$refs.xTable.clearCheckboxRow();modaltable.table=[];modaltable.head=[];"-->
		<vxe-modal ref="filtermodal" title="筛选条件" :mask="false" :show-zoom="true" :resize="true" :lock-view="false"
			width="700" height="500" remember :zIndex="2001">
			<template v-slot:header>
				<el-button @click="select" :loading="loading" :disabled="loading">查询</el-button>
				<el-button @click="clearItem">清除</el-button>
				<el-button @click="$refs.filtermodal.close()">退出</el-button>
			</template>
			<template v-slot>
				<div style="width: 100%;">
					<c-filter :dataSource="filterList" :form="filterForm" :wrap="true"></c-filter>
				</div>
			</template>
		</vxe-modal>
	</div>
</template>

<script>
	import cfilter from './filter.vue'
	export default {
		props:{
			menuId:{
				type:String,
				default:''
			},
			label:{
				type:String,
				default:''
			}
		},
		data() {
			return {
				filterClose:false,
				loading: false,
				exportload:false,
				filterForm: {},
				filterList: [],
				pageloading:false,
				table: {
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: [],
					_height: undefined,
					rowid:'_column_id'
				},
				checkList:[],
				printLoad:false,
				errCloseload:false
			}
		},
		computed: {
			TabItem() {
				if (this.routePath) {
					return {};
				}
				if (this.$route.meta.menu) {
					return this.$route.meta.menu[this.$route.fullPath];
				}
				return {};
			},
			tablehead(){
				let current= this.$store.getters.GetHomeTabMenuId;
				if(current=='GYSErr')
					return require('../assets/ChangeData.js').default.header.pursh.report1;
				else if(current=='GYSDo')
					return require('../assets/ChangeData.js').default.header.pursh.report2;
				else return [];
			},
			userinfo() {
				return this.$store.getters.UserInfo;
			},
			showFilters(){
				if(!this.filterClose) return this.filterList.slice(0,2);
				else return this.filterList;
			},
			TableRowSpan(){
				let current= this.$store.getters.GetHomeTabMenuId;
				if(this.menuId=='GYSDZ'&&this.userinfo.accountType=='cgy') return 5;
				return 4;
			},
			TableRowCount(){
				let len=this.filterClose?this.filterList.length:2;
				return Math.ceil(len/this.TableRowSpan)
			}
		},
		components: {
			'c-filter': cfilter
		},
		methods: {
			errorClose(){
				try{
					let form=[]
					for(let i in this.checkList){
						let item=this.checkList[i];
						if(!item['error']) throw '勾选行中有不需要关闭异常的数据，请先检查';
						if(item['_errclose']) throw '勾选行中存在已经关闭异常的数据，请先检查';
						if(!item['_id']) throw '数据错误，请先联系管理员';
						form.push({
							finterid:item['_id'],
							fentryid:item['_id']
						})
					}
					this.errCloseload=true;
					let ftype=this.menuId=='GYSErr'?'GYSERR':'';
					ftype=this.menuId=='GYSDo'?'GYSDo':ftype;
					this.$BH().insertErrorClose({
						data:{
							dtview:this.checkList,
							user: this.userinfo.fnumber,
							usertype: this.userinfo.accountType,
							form:{
								ftype:ftype,
								itemData:form
							}
						},
						success:(response)=>{
							this.$BH().message(response.data.value);
							this.select();
						},
						loadingcontrol: () => {
							this.errCloseload = false;
							this.operate = false;
						}
					})
				}catch(e){
					this.$BH().message(e);
					this.errCloseload=false;
					this.loading = false;
				}
			},
			VailShow(item){
				// let current= this.$store.getters.GetHomeTabMenuId;
				// console.log(item['name']=='#gysnumber#',this.menuId)
				if(this.menuId=='GYSASNLabel'){
					if(item['name']=='#gysnumber#') return false;
					else return true;
				}else if(this.menuId=='GYSDZ'&&item['name']=='#fgysname#'&&this.userinfo.accountType=='gys') return false;
				else	return true;
			},
			itemprint(){
				try{
					if(this.loading) return;
					this.printLoad=true;
					this.loading=true;
					this.$BH().commit('print.toPrint', {
						data: {
							strUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							moudleData: this.checkList,
							templateNumber:'002',
							FuncNumer:'GYSASN',
						},
						type:'print',
						IsDataSet:true,
						loadingcontrol: (res) => {
							this.printLoad=false;
							this.loading = false;
						},
						machCode:this.$store.getters.GUID
					});
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.printLoad=false;
					this.loading = false;
				}
				
			},
			listenToChild(e){
				if(e&&e['sizeChange']) this.table.pagesize=e['sizeChange'];
				else if(e&&e['checkList']) this.checkList=e['checkList'];
			},
			exportData(){
				try{
					let {head,data}=this.table;
					if(head.length>0&&data.length>0){
						if(this.exportload) return;
						this.exportload=true;
						this.$BH().getFileByteArr({
							loadingcontrol:(res)=>{
								if(res!='success')
									this.exportload=true;
							},
							data:{
								FUser:this.userinfo.fnumber,
								FType:this.userinfo.accountType,
								table:data,
								head:head
							},
							success:(res)=>{
								let basestr=res.data.value;
								this.exportload=true;
								if(basestr==''){
									this.$BH().message('返回数据错误');
									this.exportload=false;
								}else 
									this.$BH().DownLoadBase64({
										data:{
											name:this.label||this.menuId,
											base64Str:basestr
										},
										loadingcontrol:()=>{
											this.exportload=false;
										}
									});
							}
						});
					}else throw '当前无数据不需要导出';
				}catch(e){
					this.$BH().message(e);
				}
			},
			tableRowClass({row, rowIndex}){
				if(!row['error']) return '';
				if(String(row['error'])=='red')
					return 'table_row_publine_red'; 
				else if(String(row['error'])=='yellow')
					return 'table_row_publine_yellow';
				else return String(row['error']);
			},
			tableCellClass() {
				return ({
					row,
					column,
					rowIndex,
					columnIndex
				}) => {
					let {
						property
					} = column;
					var judycolor=function(){
						if(String(row['error'])=='red')
							return 'table_row_publine_red'; 
						else if(String(row['error'])=='yellow')
							return 'table_row_publine_yellow';
						else return String(row['error']);
					}
					// console.log(this.menuId)
					if(this.menuId=='GYSErr'||this.menuId=='GYSDo'){
						if (property == '异常状态') {
							// console.log(row.error,!row._errclose,judycolor())
							if (row.error) {
								if (!row._errclose)
									return judycolor();
							}
						}
					}
					else judycolor();
					return '';
				}
			},
			makeloading(e) {
				let {
					to,
					text
				} = e;
				this.pageloading = to;
				// if (text && text.toLowerCase() != 'success') alert(text);
			},
			clearItem(){
				for(let i in this.filterForm){
					this.filterForm[i]=''
				}
			},
			select() {
				try {
					console.log('---------')
					if(this.loading) return;
					this.loading = true;
					this.table.data=[];
					if(this.menuId=='GYSASN') this.createdLabel();
					else{
						this.$BH().commit('report.GetRptData', {
							data: {
								FUser: this.userinfo.fnumber,
								strFunc: this.menuId,
								Filter: [this.filterForm],
								strPage: '',
								FType:this.userinfo.accountType,
								isHeader:!(this.table.head&&this.table.head.length>0)
							},
							loadingcontrol: (res) => {
								this.loading = false;
							},
							success: (response) => {
								let {
									table,header
								} = response.data.value;
								this.table.data=table;
								if(!(this.table.head&&this.table.head.length>0))
									this.table.head=header;
								this.$refs.ctable.checkColumnChange();
								// setTimeout(()=>{
								// 	this.$forceUpdate()
								// },100);
							}
						});
					}
					
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
				}

			},
			initPage(){
				this.$BH().commit('report.initPage', {
					data: {
						FUser: this.userinfo.fnumber,
						strFunc: this.menuId,
						strPage: '',
						FType:this.userinfo.accountType,
						FFormName: 'frmReport'
					},
					loadingcontrol: (res) => {
						this.makeloading({
							to: false,
							text: res
						})
					},
					success: (response) => {
						let {
							reportFilter,columns
						} = response.data.value;
						// this.table.head=columns;
						let filterarr;
						if (reportFilter && reportFilter.length > 0) filterarr = reportFilter;
						// else filterarr = columns;
						//列名 数据类型
						let tempFilter = []
						for (let i in filterarr) {
							let name = '标题';
							let currentobj = {};
							currentobj['Display'] = filterarr[i][name];
							currentobj['name'] = filterarr[i]['关键字'];
							if(currentobj['Display'].includes('确认状态')){
								currentobj['valueName'] = 'valueName'
								currentobj['displayName'] = 'displayName'
								currentobj['dataSource'] = [{
										valueName: '',
										displayName: '全部'
									},
									{
										valueName: '已确认',
										displayName: '已确认'
									},
									{
										valueName: '未确认',
										displayName: '未确认'
									}
								]
								currentobj['dataType'] = 'text'
								currentobj['type'] = 2;
							}else if(currentobj['Display'].includes('发布状态')){
								currentobj['valueName'] = 'valueName'
								currentobj['displayName'] = 'displayName'
								currentobj['dataSource'] = [{
										valueName: '',
										displayName: '全部'
									},
									{
										valueName: '已发布',
										displayName: '已发布'
									},
									{
										valueName: '未发布',
										displayName: '未发布'
									}
								]
								currentobj['dataType'] = 'text'
								currentobj['type'] = 2;
							}else if(currentobj['Display'].includes('到货核签')&&this.menuId=='GYSDo'){
								currentobj['valueName'] = 'valueName'
								currentobj['displayName'] = 'displayName'
								currentobj['dataSource'] = [{
										valueName: '',
										displayName: '全部'
									},
									{
										valueName: '已签核',
										displayName: '已签核'
									},
									{
										valueName: '未签核',
										displayName: '未签核'
									}
								]
								currentobj['dataType'] = 'text'
								currentobj['type'] = 2;
							}else if(currentobj['Display'].includes('订单关闭')&&(this.menuId=='GYSDo'||this.menuId=='GYSErr')){
								currentobj['valueName'] = 'valueName'
								currentobj['displayName'] = 'displayName'
								currentobj['dataSource'] = [{
										valueName: '',
										displayName: '全部'
									},
									{
										valueName: '关闭',
										displayName: '关闭'
									},
									{
										valueName: '未关闭',
										displayName: '未关闭'
									}
								]
								currentobj['dataType'] = 'text'
								currentobj['type'] = 2;
							}else if(currentobj['Display'].includes('异常状态')&&this.menuId=='GYSErr'){
								currentobj['valueName'] = 'valueName'
								currentobj['displayName'] = 'displayName'
								currentobj['dataSource'] = [{
										valueName: '',
										displayName: '全部'
									},
									{
										valueName: '异常',
										displayName: '异常'
									},
									{
										valueName: '正常',
										displayName: '正常'
									}
								]
								currentobj['dataType'] = 'text'
								currentobj['type'] = 2;
							}
							else if(currentobj['Display'].includes('是否入账')&&this.menuId=='GYSDZ'){
								currentobj['valueName'] = 'valueName'
								currentobj['displayName'] = 'displayName'
								currentobj['dataSource'] = [{
										valueName: '已入账',
										displayName: '已入账'
									},
									{
										valueName: '未入账',
										displayName: '未入账'
									},
									{
										valueName: '',
										displayName: '全部'
									}
								]
								currentobj['dataType'] = 'text'
								currentobj['type'] = 2;
							}
							else if (filterarr[i]['数据类型'].includes('varchar') || filterarr[i]['数据类型'].includes(
									'String') || filterarr[i]['数据类型'].includes('文本')) {
								currentobj['dataType'] = 'text'
								currentobj['type'] = 1;
							} else if (filterarr[i]['数据类型'].includes('datetime') || filterarr[i]['数据类型'].includes(
									'DateTime') || filterarr[i]['数据类型'].includes('日期')) {
								currentobj['dataType'] = '日期';
								currentobj['type'] = 3;
							} else if (filterarr[i]['数据类型'].includes('bit') || filterarr[i]['数据类型'].includes(
									'Bool') || filterarr[i]['数据类型'].includes('真假')) {
								currentobj['type'] = 4;
							} else if (filterarr[i]['数据类型'].includes('数量')) {
								currentobj['dataType'] = 'number'
								currentobj['type'] = 1;
							}
							if (currentobj['type'])
								tempFilter.push(currentobj);
							this.filterForm[currentobj['name']]=''
						}
						if(this.menuId=='GYSASNLabel'){
							this.filterForm['#gysnumber#']=this.userinfo.fnumber;
						}
						console.log(tempFilter)
						// this.table.head = columns;
						this.filterList = tempFilter;
						if(this.menuId=='GYSDo'){
							//默认到货日期为当前日期
							let {strValue}=this.$BH().base.getDate();
							console.log(strValue);
							this.filterForm['#Fdatefrom#']=strValue;
							this.filterForm['#fdateto#']=strValue;
						}else if(this.menuId=='GYSErr'){
							this.filterForm['#FERROR#']='异常';
						}else if(this.menuId=='GYSDZ'){
							this.filterForm['#fisRZ#']='未入账';
						}
						this.filterForm
						if(this.menuId=='GYSDZ'&&this.userinfo.accountType=='gys'){//
							this.filterForm['#fgysname#']=this.userinfo.fname;
							this.filterList=require('../assets/ChangeData.js').default.filter.report.DZ;
						}
						this.filterForm=Object.assign({},this.filterForm);
						
						// this.$forceUpdate()
					}
				});
			}
		},
		activated() {
			// console.log('activated')
			// console.log(this.TabItem,this.$route.meta.menu[this.$route.fullPath])
			if (this.pageloading == false) {
				this.table._height = '85%';
			}
			console.log('activated')
		},
		deactivated() {
			// console.log('deactivated')
			// if(this.pageloading==false){
			if (document.getElementsByClassName('print_selecttable_div') && document.getElementsByClassName(
					'print_selecttable_div')[0])
					this.table._height = document.getElementsByClassName('print_selecttable_div')[0].offsetHeight * 0.85;
			// }
			console.log('deactivated')
		},
		mounted() {
			// console.log(this.$refs.ctable.$el.offsetHeight)
			// this.table._height = this.$refs.ctable.$el.offsetHeight * 0.95;
			// this.table._height = this.$refs.ctable.$el.offsetHeight*0.90+'px';//auto
			// this.table._height = 'auto';
			// this.table.head=this.tablehead;
		},
		created() {
			try{
				this.makeloading({
					to: true,
				});
				this.initPage();
			}catch(e){
				//TODO handle the exception
				this.makeloading({
					to: false,
				});
				this.$BH().message(e);
			}
			
			// this.table._height = document.getElementsByClassName('print_selecttable_div')[0].offsetHeight * 0.95;
			// console.log(this.table._height)
		}
	}
</script>

<style scoped>
	.container_cloumn {
		flex-direction: column;
		height: 100%;
		width: 100%;
	}

	.vxe-toolbar.size--mini * {
		font-size: var(--font_small);
	}

	.table_height {
		height: 4rem;
		height: calc(100% - 4rem);
		/* overflow: auto; */
	}
	.pursh_filter{
		padding: 0 .5em;
		width: 60%;
	}
	.filter_btns{
		width: 13rem;
		height: 100%;
	}
	.container_cloumn{
		min-width: 40rem;
	}
	._button span{
		font-weight: 100;
	}
	.pursh_main{
		padding: .1rem .7rem;
		height: 100%;
	}
	.pursh_mainBtn{
		width: 40%;
	}
	.el-col .el-button--default{
		width: 30%;
	}
	.el-col .el-button--primary{
		margin-left: .3rem;
	}
	.pursh_filter_btn{
		width: 15%;
	}
</style>
